import { render, staticRenderFns } from "./UpdateNewClient.vue?vue&type=template&id=f127263e"
import script from "./UpdateNewClient.vue?vue&type=script&lang=js"
export * from "./UpdateNewClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports